import mongoose from 'mongoose';
import schema, { ICancellationChargeDocument } from '../schemas/cancellation-charge';

const CancellationCharge = (mongoose.models.CancellationCharge ||
  mongoose.model<ICancellationChargeDocument>('CancellationCharge', schema)) as mongoose.Model<
  ICancellationChargeDocument
>;

export default CancellationCharge;
